import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="cx-page flex items-center justify-center" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-3 text-[color:var(--cx-fg-muted)]">
          <Loader2 className="h-7 w-7 animate-spin text-[color:var(--cx-primary)]" />
          <span className="text-sm">Securing your session…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}
